import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function closeExportExperienceSettingsModal(): RootActionTypes {
  return {
    type: ActionTypes.CLOSE_EXPORT_EXPERIENCE_SETTINGS_MODAL,
  };
}
